import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import for React 18
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Create a root and render the app using the new React 18 API
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
